var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-link',{staticClass:"nav-link favorite-action",class:{'is-favorite': _vm.media.favorite},on:{"click":_vm.onToggleFavorite}},[_c('div',{staticClass:"icon-bg"},[(_vm.loading)?_c('b-spinner',{staticClass:"spin",attrs:{"label":"Loading...","size":"sm"}}):_c('Icon',{class:{'bump': _vm.bumping},attrs:{"name":"heart","width":_vm.iconWidth}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }